import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
export { DEFAULT_BREAKPOINTS } from './constants';
var _point_elementHeight;
export const adjustBreakpointHeight = (breakpoints, heightDelta)=>breakpoints.map((point)=>_object_spread_props(_object_spread({}, point), {
            elementHeight: (_point_elementHeight = point.elementHeight) !== null && _point_elementHeight !== void 0 ? _point_elementHeight : 0 + heightDelta
        }));
export const createGridBreakpoint = ({ screenWidth: maxWidth , containerWidth , elementSpacing , elementHeight , elementsPerRow  })=>({
        maxWidth,
        elementWidth: (containerWidth + elementSpacing) / (elementsPerRow + elementSpacing) - elementSpacing,
        elementHeight
    });
